/* Click-to-load players and filter chips. Used by the Media page (sections/media-reviews.liquid, `data-media-reviews`) and the
   product page videos (sections/product-videos.liquid, `data-video-players`). Deferred per-page script.
   1. Click-to-load players: a thumbnail link is swapped for a youtube-nocookie iframe on click. One video plays at a
      time (starting another puts the first one's thumbnail back). Ctrl/Cmd/Shift/middle clicks keep opening YouTube.
   2. Filter chips (single select, by kind or by model) over the grid cards. The chips are hidden until this script runs, so without JS
      every video is listed and each thumbnail is still a link to YouTube. */
(function () {
  var roots = document.querySelectorAll('[data-media-reviews], [data-video-players]');
  if (!roots.length) return;

  var active = null;

  function stop() {
    if (active && active.box.isConnected) active.box.replaceWith(active.link);
    active = null;
  }

  function play(link) {
    stop();
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(link.getAttribute('data-mr-video')) + '?autoplay=1&rel=0&playsinline=1';
    iframe.title = link.getAttribute('data-mr-title') || 'Video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    var box = document.createElement('div');
    box.className = link.className + ' is-playing';
    box.appendChild(iframe);
    link.replaceWith(box);
    active = { box: box, link: link };
    iframe.focus();
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-mr-video]');
    if (!link || !link.closest('[data-media-reviews], [data-video-players]')) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    play(link);
  });

  roots.forEach(function (root) {
    var tools = root.querySelector('[data-mr-tools]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-mr-chip]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mr-card]'));
    var status = root.querySelector('[data-mr-status]');
    if (!tools || chips.length < 2) return;
    tools.hidden = false;

    function select(key) {
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', chip.getAttribute('data-mr-chip') === key ? 'true' : 'false');
      });
      var shown = 0;
      cards.forEach(function (card) {
        var show = key === 'all' || card.getAttribute('data-mr-model') === key || card.getAttribute('data-mr-kind') === key;
        if (!show && active && card.contains(active.box)) stop();
        card.hidden = !show;
        if (show) shown += 1;
      });
      if (status) status.textContent = 'Showing ' + shown + (shown === 1 ? ' video' : ' videos');
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () { select(chip.getAttribute('data-mr-chip')); });
    });
  });
})();
